import React from 'react';
import Skeleton from 'react-loading-skeleton';

const FeedbackStatsLading = () => {
    return (
        <div>
            <p className="m-0 w-100">
                <Skeleton width="100%" highlightColor='#ffffff' baseColor='#f3f3f3' />
            </p>
            <h5 className="m-0 w-100">
                <Skeleton width="50%" highlightColor='#ffffff' baseColor='#f3f3f3' />
            </h5>
        </div>
    )
}

export default FeedbackStatsLading;
